import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, SocketEvents } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { 
	CleanIcon, 
	AddIcon, 
	EditIcon, 
	TrashIcon, 
	ViewIcon,
	FacebookSquareIcon,
	InstagramSquareIcon,
	WhatsappSquareIcon,
	ApiSquareIcon,
	TiktokSquareIcon,
	InfoIcon,
	ArrowLeftBlack,
	LoadingGif,
	SendIcon
} from 'assets/icons';
import { ReportService } from 'services';
import moment from 'moment';
import * as Jetemit from 'jetemit';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
    since: '',
    until: '',
	client_id: '',
	search: ''
}

const MOBILE_QUERY = '(max-width: 767px)';

class ConsultationReport extends React.Component<Props> {

	timer: any = undefined;
	messagesEnd: any = null;

	state = {
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		clients: [],
		chat: null,
		consultations_count: 0,
		loading: true,
		session: null,
		unsubscriber: () => {},
		consultations: [],
		chat_page: 1,
		chat_last_page: 1,
		form_message: {
			message: ''
		},
		waiting_response: false,
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Conversaciones',
				onBack: null
			}
		});

		this.setState({
			unsubscriber: Jetemit.on(SocketEvents.CHATS.MESSAGE,(data: any) => {
				if (data.session == this.state.session) {
					let consultations = [...this.state.consultations];
					// @ts-ignore
					consultations.push(data.consultation);
					this.setState({
						consultations
					},() => this.scrollToBottom());
				}
			})
		});

		this.loadChats();
		this.loadClients();
	}

	componentWillUnmount() {
		this.state.unsubscriber();
	}

	loadClients = async () => {
		const res: any = await ReportService.admin.getClients({
			withoutLoading: true
		});
		this.setState({
			clients: res.clients || []
		});
	}

	loadChats = async (withoutLoading = false) => {
		const res: any = await ReportService.admin.loadChats({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: moment(this.state.form.since).isValid() ? moment(this.state.form.since).format('YYYY-MM-DD') : '',
			until: moment(this.state.form.until).isValid() ? moment(this.state.form.until).format('YYYY-MM-DD') : ''
		});
		this.setState({
			data: res.chats.rows,
			last_page: res.chats.count,
			consultations_count: res.count || 0,
		},() => {
			if (res.chats?.rows?.length > 0 && !window.matchMedia(MOBILE_QUERY).matches) {
				this.setState({
					session: res.chats?.rows[0].value
				},() => {
					this.load(true);
				});
			}
		});
	}

	load = async (withoutLoading = false, load_more = false) => {
		await this.setState({
			loading: true
		});
		const res: any = await ReportService.admin.viewConsultation({
			session: this.state.session,
			withoutLoading,
			page: this.state.chat_page
		});
		if (res.result) {
			this.setState({
				consultations: load_more ? [
					...(res.consultations || []),
					...this.state.consultations
				] :  (res.consultations || []),
				loading: false,
				chat_last_page: res.last_page || 1,
				chat: res.chat
			},() => {
				if (load_more) {
					this.scrollToTop();
				}
				else {
					this.scrollToBottom();
				}
			});
		}
	}

	scrollToBottom = () => {
		this.messagesEnd.scrollTo({
			behavior: 'smooth',
			top: this.messagesEnd.scrollHeight
		});
	}

	scrollToTop = () => {
		this.messagesEnd.scrollTo({
			behavior: 'smooth',
			bottom: this.messagesEnd.scrollHeight
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changeMessage = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form_message: {
				...this.state.form_message,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.loadChats(true));
	}

	getIcon = (item: any) => {
		if (item.facebook_id) {
			return FacebookSquareIcon;
		}
		else if (item.phone) {
			return WhatsappSquareIcon;
		}
		else if (item.instagram_id) {
			return InstagramSquareIcon;
		}
		else if (item.tiktok_id) {
			return TiktokSquareIcon;
		}
		else {
			return ApiSquareIcon;
		}
	}

	loadMore = (e: any) => {
		e.preventDefault();
		this.setState({
			chat_page: this.state.chat_page + 1
		},() => this.load(true,true));
	}

	changeStatus = async (e: any) => {
		e.preventDefault();
		await ReportService.admin.changeStatus({
			// @ts-ignore
			session_id: this.state.chat?.id
		});
		this.setState({
			chat: {
				// @ts-ignore
				...this.state.chat,
				// @ts-ignore
				status: !this.state.chat?.status
			}
		});
	}

	send = async (e: any) => {
		e.preventDefault();
		if (!this.state.waiting_response && this.state.form_message.message) {
			const message = this.state.form_message.message;
			let consultations: any = [...this.state.consultations];
			consultations.push({
				response: message
			});
			await this.setState({
				consultations,
				waiting_response: true,
				form_message: {
					...this.state.form_message,
					message: ''
				}
			},() => this.scrollToBottom());
			const res: any = await ReportService.admin.sendResponseSocial({
				message,
				withoutLoading: true,
				// @ts-ignore
				session: this.state.chat?.value
			});
			consultations.pop();
			consultations.push(res.consultation);
			this.setState({
				consultations,
				waiting_response: false
			},() => this.scrollToBottom());
		}
	}

	back = (e: any) => {
		e.preventDefault();
		this.setState({
			consultations: [],
			loading: false,
			chat_last_page: 1,
			chat: null,
			session: null
		});
	}

	keydown = (e: any) => {
	  if (e.nativeEvent.keyCode == 13) {
	  	e.preventDefault();
	  	this.send(e);
	  }
	}

	render() {
		const { loading } = this.state;
		const chat: any = this.state.chat;

		return (
			<div id="consultations-report">
				<div id="view-consultation">
					<div className="container-list-chats">
						<div className={ `container-search ${ chat == null ? 'visible' : '' }` }>
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								searchLeft={ true }
								className="input-table"
								onSubmit={ () => this.loadChats(true) }
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.loadChats(true);
									},1000);
									this.change(e); 
								} } />
							<div className="list-chats">
								{
									this.state.data.map((item: any) => {
										return (
											<a href="#" className={ `item-chat ${ item.value == this.state.session ? 'active' : '' }` } onClick={ (e: any) => {
												e.preventDefault();
												this.setState({
													session: item.value,
													chat_page: 1,
													chat_last_page: 1
												},() => this.load());
											} }>
												<div className="container-blue">
													<div className="container-icon">
														<img src={ this.getIcon(item) } />
														<div style={{ flex: 1 }}>
															<p className="bold">{ item?.name || item?.phone || item?.value }</p>
														</div>
													</div>
													<p>{ item.last_consultation?.response || '-' }</p>
													<p className="date">{ moment(item.updated_at || item.created_at).format('DD/MM/YYYY HH:mm') }</p>
												</div>
											</a>
										)
									})
								}

								{
									this.state.data?.length == 0 && (
										<div className="text-center">
											<p className="no-messages">No se han encontrado chats</p>
										</div>
									)
								}

								<Pagination 
									pages={ this.state.last_page } 
									active={ this.state.page }
									onChange={ async (page: number) => {
										await this.setState({
											page: page
										});
										this.loadChats();
									} } />
							</div>
						</div>
						{
							chat != null && (
								<div className={ `container-messages ${ chat != null ? 'visible' : '' }` }>
									<div className="header-black">
										<div className="container-back">
											<a href="#" className="back" onClick={ this.back }>
												<img src={ ArrowLeftBlack } />
											</a>
											<div className="container-name">
												<h5 style={{ marginBottom: chat?.subtitle == null ? '0px' : '5px' }}>{ chat?.name || chat?.phone || chat?.value }</h5>
												{
													chat?.subtitle != null && (
														<h6>{ chat?.subtitle }</h6>
													)
												}
											</div>
										</div>
										{
											(chat?.facebook_id || chat?.instagram_id || chat?.phone) && (
												<div className="container-toggle">
													<a href="#" className={ `toggle ${ !chat?.status ? 'disabled' : '' }` } onClick={ this.changeStatus }>
														<div className="toggle-circle"></div>
													</a>
													<Tooltip title="La acción activa o inhabilita el agente solo para esta conversación">
														<img src={ InfoIcon } />
													</Tooltip>
												</div>
											)
										}
									</div>
									<div className="container-black" ref={ (el) => { this.messagesEnd = el; } }>
										{
											this.state.chat_page < this.state.chat_last_page && (
												<div className="text-center">
													{
														loading ? (
															<i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>
														) : (
															<a href="#" className="link-more" onClick={ (e: any) => this.loadMore(e) }>
																Cargar más mensajes
															</a>
														)
													}											
												</div>
											)
										}

										{
											this.state.consultations.map((item: any) => {
												return (
													<>
														{
															item.question && (
																<div className="item-message">
																	<div style={{ width: '100%' }}>
																		<p className="message">{ item.question }</p>
																		<p className="date">{ moment(item.created_at || item.updated_at).format('DD/MM/YYYY HH:mm') }</p>
																	</div>
																</div>
															)
														}
														{
															item.response && (
																<div className="item-message item-left">
																	<div style={{ width: '100%' }}>
																		<p className="message">{ item.response }</p>
																		<p className="date">{ moment(item.created_at || item.updated_at).format('DD/MM/YYYY HH:mm') }</p>
																	</div>
																</div>
															)
														}
													</>
												)
											})
										}

										{
											!this.state.loading && this.state.consultations.length == 0 && (
												<div className="text-center">
													<p className="no-messages">No se han encontrado mensajes</p>
												</div>
											)
										}
									</div>
									{
										(chat?.facebook_id || chat?.instagram_id || chat?.phone) && (
											<div className="container-send">
												<Input
													value={ this.state.form_message.message }
													name="message"
													placeholder="Escribir"
													onKeyDown={ (e: any) => this.keydown(e) }
													onChange={ (e: any) => this.changeMessage(e) } />
												{
													this.state.waiting_response ? (
														<img src={ LoadingGif } />
													) : (
														<a href="#" onClick={ (e: any) => this.send(e) }>
															<img src={ SendIcon } />
														</a>
													)
												}
											</div>
										)
									}
								</div>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ConsultationReport);